var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen overflow-hidden",attrs:{"id":"app"}},[_c('Hangman')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }